<template>
    <div class="OptionAssociation">
        <el-button type="text" @click="setOptionAssociation" v-if="optionAssociationList.length > 0">选项关联</el-button>
        <el-dialog class="option-association" title="选项关联" :visible.sync="AssociationShow" :close-on-click-modal="false" :close-on-press-escape="false" width="40%">
            <el-form ref="optionAssociation" label-width="70px" class="demo-dynamic" style="margin-top: 13px; max-height: 400px; overflow: auto">
                <el-form-item v-for="(item, index) in questionRelationList" :key="index">
                    <div class="choiceQuestion" style="float: left">
                        <span style="margin-right: 10px">将题目</span>
                        <el-select v-model="item.id" placeholder="请选择选项" value-key="id" @change="relationChange" @visible-change="relationVisibleChange">
                            <template v-for="info in optionAssociationList">
                                <el-option :key="info.qid" :label="$functions.htmlFormat(info.questionsName)" :value="info.qid"></el-option>
                            </template>
                        </el-select>
                        <span style="margin-left: 10px">选中项作为本题选项</span>
                    </div>
                    <div class="icon_num">
                        <i style="cursor: pointer;" class="icon iconfont iconjian" @click="removeAssociation(item)"></i>
                        <i style="cursor: pointer;" class="icon iconfont iconjia" @click="addAssociation(index)"></i>
                    </div>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="cancelAssociation">取 消</el-button>
                <el-button size="medium" type="primary" @click="saveAssociation">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'OptionAssociation',
    props: {
        paper: {
            type: Object,
            default: () => {
                return {}
            }
        },
    },
    data() {
        return {
            AssociationShow: false,
            activeQuestion: {},
            questionRelationList: [],
            optionAssociationList: []
        }
    },
    watch: {
        'paper.questionsList': {
			handler(vnew, vold) {
				let index = this.paper.questionsList.findIndex((info) => {
					return info.isedit == true
				})
				if (index != -1) {
					this.activeQuestion = this.paper.questionsList[index]
				} else {
					this.activeQuestion = {}
				}
				// console.log('this.activeQuestion :>> ', this.activeQuestion);
			},
			deep: true,
            immediate: true
		},
    },
    created() {
		this.setOptionAssociationList();
		if (this.activeQuestion.relation) {
			this.questionRelationList = JSON.parse(JSON.stringify(this.activeQuestion.relation));
		} else {
			this.questionRelationList = [{
				id: ''
			}]
		}
    },
    methods: {
        cancelAssociation() {
            this.AssociationShow = false
        },
        setOptionAssociation() {
			this.AssociationShow = true;
		},
		setOptionAssociationList() {
			this.optionAssociationList = [];
			let quesTypeArr = [100, 101];
			let list = this.paper.questionsList;
			for (let i = 0; i < list.length; i++) {
				if (list[i].qid == this.activeQuestion.qid) {
					break;
				}
				if (quesTypeArr.indexOf(list[i].questionsTypeId) !== -1) {
					this.optionAssociationList.push(list[i]);
				}
			}
		},
		saveAssociation() {
			this.activeQuestion.relation = JSON.parse(JSON.stringify(this.questionRelationList));
			// console.log(this.activeQuestion.relation);
			this.AssociationShow = false
		},
		relationVisibleChange(e) {
			if (e) {
				this.setOptionAssociationList();
				let newListArr = [];
				let newListArr2 = [];
				this.questionRelationList.forEach(info => {
					newListArr.push(info.id);
				});
				newListArr2 = this.optionAssociationList.filter(item => {
					if (newListArr.indexOf(item.qid) == -1) {
						return item;
					}
				});
				this.optionAssociationList = newListArr2;
				// console.log(this.optionAssociationList);
			}
		},
		relationChange(e) {
			this.paper.questionsList.forEach(info => {
				if (info.qid == e) {
					if (!info.associated) {
						info.associated = []
					}
					if (info.associated.indexOf(this.activeQuestion.qid) == -1) {
						info.associated.push(this.activeQuestion.qid);
					}
				}
			});
		},
		addAssociation() {
			this.questionRelationList.push({ id: '' });
		},
		removeAssociation(item) {
			// console.log(item);
			var index = this.questionRelationList.indexOf(item);
			// console.log(index);
			if (index !== -1) {
				this.questionRelationList.splice(index, 1);
				this.paper.questionsList.forEach(info => {
					if (info.qid == item.id) {
						let elIndex = info.associated.indexOf(this.activeQuestion.qid);
						if (elIndex !== -1) {
							info.associated.splice(elIndex, 1);
						}
					}
				});
			}
			if (this.questionRelationList.length <= 0) {
				this.questionRelationList.push({ id: '' });
			}
			this.relationVisibleChange(true);
		},
    }
}
</script>

<style lang="scss" scoped>
.OptionAssociation{
    margin-left: 10px;
    // height: 44px;
    .icon_num i {
		font-size: 20px;
		color: #ccc;
		margin-left: 10px;
		float: left;
	}
}
</style>